import type { SavePhase } from '../types/setup';
import { SAVE_PHASE_LABELS } from '../types/setup';

interface SaveProgressProps {
  phase: SavePhase;
  error: string | null;
  onCancel: () => void;
}

const PHASE_ORDER: Exclude<SavePhase, 'idle'>[] = ['validating', 'saving', 'locking', 'completed'];

export function SaveProgress({ phase, error, onCancel }: SaveProgressProps) {
  if (phase === 'idle') return null;

  const currentIdx = PHASE_ORDER.indexOf(phase as Exclude<SavePhase, 'idle'>);

  return (
    <div className="progress-overlay" role="dialog" aria-modal="true" aria-labelledby="progressTitle">
      <div className="progress-modal">
        <h2 className="progress-title" id="progressTitle">
          Setting up your card
        </h2>

        <ul className="progress-steps">
          {PHASE_ORDER.map((step, idx) => {
            const done = idx < currentIdx;
            const active = idx === currentIdx;
            return (
              <li
                key={step}
                className={`progress-step${done ? ' done' : ''}${active ? ' active' : ''}`}
              >
                <span className="progress-step-dot" aria-hidden="true">
                  {done ? '✓' : idx + 1}
                </span>
                <span>{SAVE_PHASE_LABELS[step]}</span>
              </li>
            );
          })}
        </ul>

        {error && (
          <>
            <p className="progress-error" role="alert">
              {error}
            </p>
            <button type="button" className="btn" onClick={onCancel}>
              Close
            </button>
          </>
        )}

        {!error && phase !== 'completed' && (
          <p className="hint scanning-hint">Please wait…</p>
        )}
      </div>
    </div>
  );
}
